import { useCallback } from 'react';
import { DriverGroupsForm } from '../components/DriverGroupsForm';
import type { DriverGroupsFormPropertiesFromDispatch } from '../../types/driverGroupsFormTypes';
import { getAllTagsInAccount } from '../../../../../../Drivers.selectors';
import { getSelectedDriverRtk } from '../../../sidebarSlice';
import { setTagsThunk } from '../../../../../../crossSliceThunks';
import { useAppDispatch, useAppSelector } from '../../../../../../../configuration/setup/hooks';

const EMPTY_TAG_IDS: string[] = [];

export const DriverGroupsFormContainer = () => {
    const dispatch = useAppDispatch();
    const allTagsInAccount = useAppSelector(getAllTagsInAccount);
    const selectedDriver = useAppSelector(getSelectedDriverRtk);
    const setTags = useCallback<DriverGroupsFormPropertiesFromDispatch['setTags']>(
        tags => dispatch(setTagsThunk(tags)),
        [dispatch]
    );

    return (
        <DriverGroupsForm
            allTagsInAccount={allTagsInAccount}
            assignedTagIds={selectedDriver?.tags ?? EMPTY_TAG_IDS}
            setTags={setTags}
        />
    );
};
